import {
	goToTabPaneByElement,
	setDisabledStateOfLockableAttributeControlsWithDefaultValues,
	setTabsVisible
} from '@/core/core_components/form/form'
import { booleanStringValueToLogicalBoolean, saveConfig } from '@/core/shared'
import { mergeDataForStateRestoring } from '@/core/item_assistance/mergeItemData'

export function ClientSessionManager (activeCompany) {
	this.activeCompany = activeCompany
	this.companyListIdSelector = '.company_list'
	this.itemConfig = {}
	this.dataJson = {}
	this.justStateSaved = false

	this.setItemConfig = function (itemConfig) {
		this.itemConfig = itemConfig
	}

	this.submitSelectedCompany = function (companyId, updateProfile) {
		// window.onbeforeunload()
		$.ajax({
			url: window.urlContext + 'company/use',
			type: 'POST',
			async: false,
			context: this,
			data: { companyId: companyId },
			success: function (data) {
				sessionStorage.setItem('justStateSaved', true)
				updateProfile(data)
			}
		})
	}

	this.userAuthorizeAction = function (callback, updateProfile) {
		var context = this
		$(context.companyListIdSelector + ' li').click(function () {
			var companyId = $(this).val()
			if (companyId !== context.activeCompany) {
				callback(companyId, updateProfile)
			}
		})
	}

	this.bindActions = function (updateProfile) {
		this.userAuthorizeAction(this.submitSelectedCompany, updateProfile)
	}

	this.saveItemState = function (tradeItem, isGroupMode, isEnabledDefaults) {
		this.justStateSaved = sessionStorage.getItem('justStateSaved')
		if (booleanStringValueToLogicalBoolean(this.justStateSaved)) {
			this.justStateSaved = false
			sessionStorage.setItem('justStateSaved', false)
			return false
		}

		var itemId = tradeItem.itemId ? tradeItem.itemId : false

		var unsavedData = tradeItem.unsavedDataManager.getUnsavedData()
		var state = {
			data: unsavedData,
			selectedAttribute: tradeItem.selectedAttribute,
			groupMode: isGroupMode,
			enabledDefaults: isEnabledDefaults
		};
		(itemId !== false) ? saveConfig('itemEdit.' + itemId, JSON.stringify(state)) : saveConfig('newItem_state', JSON.stringify(state))
	}

	this.dropItemState = function (itemId) {
		(itemId !== false) ? saveConfig('itemEdit.' + itemId, JSON.stringify({})) : saveConfig('newItem_state', JSON.stringify({}))
		sessionStorage.setItem('justStateSaved', true)
		document.location.reload()
	}

	this.restoreItemState = function (itemState, itemData, activeAttribute) {
		var mergedData = mergeDataForStateRestoring(itemState.data, itemData, this.itemConfig)
		initData(mergedData, false, this.itemConfig, false)
		if (itemState.groupMode) {
			setTabsVisible(true)
		}
		if (itemState.enabledDefaults) {
			setDisabledStateOfLockableAttributeControlsWithDefaultValues(false)
		}
		if (itemState.selectedAttribute && !activeAttribute) {
			var element = $('#' + itemState.selectedAttribute)
			if (!itemState.groupMode) goToTabPaneByElement(element)
			element.focus()
		}
	}

	this.saveTableState = function (table) {
		this.justStateSaved = sessionStorage.getItem('justStateSaved')
		if (booleanStringValueToLogicalBoolean(this.justStateSaved)) {
			this.justStateSaved = false
			sessionStorage.setItem('justStateSaved', false)
			return false
		}
		table.saveTableState();
	};
}
